import React,{FC, useEffect, useState} from "react";
import CarSimComponent from "./CarSimComponent";
import useScript from "./Hooks/useScript";
import { LanguageSelector } from "./LanguageSelector";
import {UseTranslationContext} from './TranslationContext';
import {CookieManager} from './CookieManager';
import 'react-notifications-component/dist/theme.css'
import Lottie from "lottie-react";
import spinner from "./FormModel/lottie_spinner_petrol.json";

import './css/normalize.css';
import './css/webflow.css';
import './css/webflow_carsim.css';
import './css/carsim.css';
import { PopupFeedbackComponent } from "./PopupFeedbackComponent";
import ReactTooltip from "react-tooltip";
import GSOHeaderComponent from "./GsoHeaderComponent";
import Footer from "./FooterComponent";

export const MainComponent:FC=()=>{

  const{currentLanguage, getKeyFromKeyId, isLoaded } = UseTranslationContext();
  const [openCookieFooter, setOpenCookieFooter] = useState(false);

  const [openFeedbackPopup, setOpenFeedbackPopup] = useState(false);

  function GetTermsUrl(){
    if(currentLanguage == 'nl')
    {
      return "https://groups.be/nl/disclaimer";
    }
    else
    {
      return "https://groups.be/fr/disclaimer";
    }
  }

  function GetContactUrl(){
    if(currentLanguage == 'nl')
    {
      return "https://groups.be/nl/contact";
    }
    else
    {
      return "https://groups.be/fr/contact";
    }
  }

return(
    <>

    <GSOHeaderComponent />

    { !isLoaded &&
      <div style={{display:"grid", justifyContent:"center", alignContent: "center", height:"100vh"}}>
        <Lottie animationData={spinner} autoPlay={true} loop={true} className="lottie-animation-main"/>
      </div>
    }
    
    { isLoaded &&
      <>
      {/*<CookieManager displayPopup={openCookieFooter} setDisplayPopup={setOpenCookieFooter} />*/}

    <ReactTooltip className='opaque leftTooltip tooltipCustomWidth' place={"left"}  id="TooltipHtml" effect="solid" html={true} overridePosition={({ left, top }, _e, _t, node) => { return { top, left: typeof node === 'string' ? left : Math.max(left, 0), };}}/>
    <ReactTooltip className='opaque leftTooltip tooltipCustomWidth' place={"left"}  id="TooltipNoHtml" effect="solid" multiline={true} overridePosition={({ left, top }, _e, _t, node) => { return { top, left: typeof node === 'string' ? left : Math.max(left, 0), };}}/>

      <main id="main" className="main wf-section">
        <div id="w-node-f5758e8e-68bd-f038-edbe-b0bedb41cbc4-7117b8a8" className="w-layout-grid grid">
          <div id="w-node-_2eb4fdd6-7858-fd81-a546-798333ef6cd0-7117b8a8" className="titre">
            <div className="no-print">
              <LanguageSelector />
            </div>     
              <div className="titre-info">
                <h2 id="titre-h2" className="title">{getKeyFromKeyId('TITLE_CARSIM')}</h2>
              </div> 
          </div>
          <section className="section-tableau">
            <CarSimComponent openFeedback={openFeedbackPopup} setOpenFeedback={setOpenFeedbackPopup}/>
          </section>
          <p id="w-node-_12f3b16d-ec87-7e85-ad4f-64f8c164b80f-a2169bf1" className="legende">{getKeyFromKeyId('INFO_02')}</p>
        </div>
      
        {/* POPUP SONDAGE */}
        {/*<PopupFeedbackComponent openFeedback={openFeedbackPopup} setOpenFeedback={setOpenFeedbackPopup}/>*/}
      
      </main>
      
      {/* FOOTER */}
        <Footer />

        <div className="border-deco-right"></div>
        <div className="border-deco-left"></div>
        </>
    } 
</>
);

}